import api from '@utils/api';

export const getSolicitationCostCenters = async () => {
  try {
    const response = await api.get('/solicitation-cost-centers');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar centros de custo:', error);
    throw error;
  }
};
